import React from 'react';
import { ISVGType } from './SVGType';

const DownArrowIcon = (props: ISVGType) => {
  const { height = 6, width = 9, color = "#454545" } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 9 6"
      fill="none"
    >
      <path
        d="M1 1L4.5 4.5L8 1"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DownArrowIcon;
